var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcessFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 33.5C0 14.9965 14.9965 0 33.5 0C52.0035 0 67 14.9965 67 33.5C67 52.0035 52.0035 67 33.5 67C14.9965 67 0 52.0035 0 33.5ZM22.9004 27.2318L29.0639 33.3822L22.9004 39.6504C21.6834 40.8805 21.6834 42.8695 22.9004 43.9818C24.1305 45.3166 26.1195 45.3166 27.2318 43.9818L33.3822 37.9361L39.6504 43.9818C40.8805 45.3166 42.8695 45.3166 43.9818 43.9818C45.3166 42.8695 45.3166 40.8805 43.9818 39.6504L37.9361 33.3822L43.9818 27.2318C45.3166 26.1195 45.3166 24.1305 43.9818 22.9004C42.8695 21.6834 40.8805 21.6834 39.6504 22.9004L33.3822 29.0639L27.2318 22.9004C26.1195 21.6834 24.1305 21.6834 22.9004 22.9004C21.6834 24.1305 21.6834 26.1195 22.9004 27.2318Z",
    fill: "url(#paint0_linear_2221_8187)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2221_8187",
    x1: 33.5,
    y1: 0,
    x2: 33.5,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0208333,
    stopColor: "#7E30E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#0072F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911458,
    stopColor: "#67ADFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessFailed);
export default __webpack_public_path__ + "static/media/process_failed.e0c6d0984cb2f489c99e2ba6eb76b2d9.svg";
export { ForwardRef as ReactComponent };